import { applyDefaultTheme } from "../theme/themeEngine";

/**
 * Boot-time theme application — thin delegate kept for the App.jsx call site.
 *
 * The old themeMap that lived here is fully superseded by src/theme/:
 *  - default variable values → tokens.css + tokens-compat.css
 *  - psb overrides → the "maroon" preset's tokenOverrides
 *    (tooling/theme/theme-presets.json → presets.generated.js)
 *  - tenant selection (psb3 → psb) → TENANT_PRESET_DEFAULTS in the presets
 *
 * Once app-properties.json arrives, App.jsx applies the real tenant theme via
 * themeEngine.applyTheme(appProperties.theme).
 */
export function applyTheme() {
  applyDefaultTheme();
}
